/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _sortBy from 'lodash.sortby';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import moment from 'moment-timezone';
import ApiService from 'cio/services/api';
import MetricsService from 'cio/services/metrics';
import { TrackedLinkMetric } from 'cio/utils/metrics/models/tracked-link-metric';
import { Periods, Entities } from 'cio/utils/metrics/common';
import EnvironmentService from 'cio/services/environment';
import TransactionalMessageModel from 'cio/models/transactional-message';
import { Grouping } from 'cio/utils/metrics/resolution';
import { TimeRange } from 'cio/utils/time';
import HydraService from 'cio/services/hydra';

interface TransactionalTopLinksArgs {
  message: TransactionalMessageModel;
  timeRange: TimeRange;
  grouping: Grouping;
}

const DEFAULT_VERTICAL_COLLECTION_CONTAINER_SELECTOR = 'body';

export default class TransactionalTopLinks extends Component<TransactionalTopLinksArgs> {
  @service api!: ApiService;
  @service hydra!: HydraService;
  @service metrics!: MetricsService;
  @service environment!: EnvironmentService;

  @tracked trackedLinkMetric: TrackedLinkMetric | null = null;

  fetchLinks = task({ restartable: true }, async () => {
    if (!this.environment.current.id) {
      return;
    }

    this.trackedLinkMetric = await this.metrics.fetchTrackedLinkMetric(
      Entities.TRANSACTIONAL,
      this.args.message.id,
      Periods.CUSTOM,
      this.utcTimeRange,
      'all',
      {
        environmentId: this.environment.current.id,
        transactionalMessageId: this.args.message.id,
      },
    );
  });

  get sortedLinkMetricStats() {
    return _sortBy(this.trackedLinkMetric?.stats, ['periodTotalClicked']).reverse() ?? [];
  }

  get utcTimeRange() {
    return {
      start: moment.tz(`${this.args.timeRange.start?.format('YYYY-MM-DD')} 00:00:00`, 'Etc/UTC'),
      end: moment.tz(`${this.args.timeRange.end?.format('YYYY-MM-DD')} 00:00:00`, 'Etc/UTC'),
    };
  }

  get verticalCollectionContainerSelector() {
    if (this.hydra.isHydraEnabled) {
      return this.hydra.config?.scrollContainerSelector ?? DEFAULT_VERTICAL_COLLECTION_CONTAINER_SELECTOR;
    }

    return DEFAULT_VERTICAL_COLLECTION_CONTAINER_SELECTOR;
  }
}
